export const concreteNouns = [
  // Animals
  "cat", "dog", "elephant", "butterfly", "dolphin", "penguin", "owl", "turtle", 
  "horse", "lion", "bear", "rabbit", "snake", "whale", "eagle", "parrot", 
  "shark", "tiger", "zebra", "giraffe", "monkey", "frog", "kangaroo",
  
  // Food
  "apple", "banana", "pizza", "cake", "bread", "cheese", "chocolate", "strawberry", 
  "watermelon", "lemon", "orange", "tomato", "mushroom", "cookie", "sandwich", 
  "hamburger", "sushi", "ice cream", "carrot", "broccoli", "grapes", "pineapple",
  
  // Nature
  "mountain", "ocean", "river", "forest", "desert", "island", "volcano", "waterfall", 
  "rainbow", "sunset", "lightning", "snowflake", "flower", "tree", "cactus", "leaf",
  
  // Objects
  "guitar", "camera", "clock", "umbrella", "telescope", "bicycle", "candle", 
  "compass", "diamond", "key", "lamp", "mirror", "pillow", "scissors", "trophy", 
  "balloon", "crown", "sword", "bell", "drum", "book", "chair", "table", "laptop",
  
  // Vehicles
  "airplane", "helicopter", "submarine", "motorcycle", "train", "sailboat", 
  "rocket", "tractor", "car", "bus", "truck", "skateboard",
  
  // Buildings/Places
  "castle", "lighthouse", "bridge", "pyramid", "windmill", "church", 
  "skyscraper", "tent", "house", "barn", "hospital", "school",
  
  // Body/Clothing
  "hat", "glasses", "boot", "glove", "ring", "necklace", "shoe", "shirt", 
  "pants", "dress", "sock", "watch",
  
  // Weather/Space
  "sun", "moon", "star", "cloud", "comet", "planet", "aurora", "astronaut"
];

/**
 * Gets a requested number of random words from the concrete nouns list.
 */
export function getRandomMemoryWords(count: number, excludeWords: string[] = []): string[] {
  const availableWords = concreteNouns.filter(word => !excludeWords.includes(word));
  
  // Shuffle available words
  const shuffled = [...availableWords].sort(() => Math.random() - 0.5);
  
  return shuffled.slice(0, Math.min(count, shuffled.length));
}
